import React from "react";
import { PackageXIcon, PuzzleIcon, RulerIcon, SearchIcon, ShuffleIcon, BoxIcon } from "lucide-react";
import { problemPains } from "../../data/salesContent";
const painIcons = [SearchIcon, ShuffleIcon, BoxIcon, RulerIcon, PackageXIcon, PuzzleIcon];
export function ProblemSection() {
  return <section className="bg-night py-8 sm:py-12" aria-labelledby="problem-title" data-id="element-154" data-mp="djd7z5b1yfad">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-155" data-mp="3vpj6b4ltd5tv">
        <h2 id="problem-title" className="text-center font-display text-[30px] font-extrabold leading-[1.05] tracking-tight text-cream sm:text-5xl" data-id="element-156" data-mp="3vnybrezi1mw0">
          Halloween Is Coming.
          <span className="mt-2 block text-muted" data-id="element-157" data-mp="3lsdh61wrfowa">Are You Still Planning Every PE Class From Scratch?</span>
        </h2>

        <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-158" data-mp="3qqyg7y0a02j5">
          {problemPains.map((pain, i) => {
          const Icon = painIcons[i];
          return <li key={pain} className="flex items-center gap-3 rounded-xl bg-navy p-3.5" data-id="element-159" data-mp="1oz1y25jlrufe" data-mpi={i}>
                <Icon className="h-5 w-5 shrink-0 text-pumpkin" aria-hidden="true" data-id="element-160" data-mp="1nnuqs3paqyj1" />
                <span className="text-[15px] leading-snug text-cream/90" data-id="element-161" data-mp="1nlqf2zl5ov87">{pain}</span>
              </li>;
        })}
        </ul>

        <div className="mt-5 rounded-3xl bg-plum p-7 text-center sm:p-10" data-id="element-162" data-mp="1wfwmjoof7qmz">
          <p className="font-display text-lg font-bold text-cream/85 sm:text-xl" data-id="element-163" data-mp="1whzc67lnvhr6">
            The problem is not that you need more ideas.
          </p>
          <p className="mt-2 font-display text-2xl font-extrabold leading-tight text-cream sm:text-3xl" data-id="element-164" data-mp="14q07mwugf6mx">
            You need a Halloween PE system you can actually use.
          </p>
        </div>
      </div>
    </section>;
}